<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let codeList = {}
  let tradePlatform = {"GTS2":"PTS","MT5":"MT5"}
  let platform = {"IOS":"IOS","Android":"Android"}
  let type = {"1":"真实","2":"模拟","3":"游客"}
  let channeList=[];
  export default {
    name: 'appproduct',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created(){
      this.$axios.post(URL.optional.getCountryDictParamList).then(res => {
        if (res.code == 0){
          for (let i in res.result) {
            codeList[res.result[i].iCodeId] = res.result[i].symbol;
          }
          this.$axios.get(URL.advertising.getData).then(res=>{
            if(res.code==0) {
              channeList = res.result.dfre;
              this.updateData.cols = [
                { title: 'id', field: 'id',hidden:true},
                { title: 'iCodeId', field: 'iCodeId',type:2,optionList:codeList,required:true},
                { title: '交易平台', field: 'tradePlatform',type:4,optionList:tradePlatform,data:[],required:true},
                { title: '应用平台', field: 'platform',type:4,optionList:platform,data:[],required:true},
                { title: '渠道', field: 'channel',type:4,optionList:channeList,data:[],hasCheckAll:true,checkAll:false,required:true},
                { title: '用户类型', field: 'type',type:4,optionList:type,data:[],required:true},
                { title: '排序', field: 'sort',type: 7,required:true},
              ]
              this.formData.cols = [
                { title: 'iCodeId', field: 'iCodeId',type:2,optionList:codeList},
                { title: '应用平台', field: 'platform',type:2,optionList:platform},
                { title: '渠道', field: 'channel',type:2,optionList:channeList},
                { title: '用户类型', field: 'type',type:2,optionList:type},
                {click:"查询"},
                {click:"新增"},
              ]
            }
          });
        }
      })

    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          row.tradePlatform = row.tradePlatform.split(",");
          row.platform = row.platform.split(",");
          row.channel = row.channel.split(",");
          row.type = row.type.split(",");
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName){
          this.dataChanage(URL.appproduct.delete,{id:row.id},res =>{
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.symbol = codeList[model.iCodeId];
        model.tradePlatform = model.tradePlatform.join(",");
        model.platform = model.platform.join(",");
        model.channel = model.channel.join(",");
        model.type = model.type.join(",");
        //根据是否包含id更新还是添加
        this.dataChanage(URL.appproduct.edit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      },
      arrTrans(data,option){
        let split = data.split(",");
        let arr = [];
        for (let i in split) {
          arr.push(option[split[i]])
        }
        return arr.join(",");
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.appproduct.list, //请求路径和参数
          sequence: true,
          cols: [
            { title: 'iCodeId', field: 'iCodeId'},
            { title: '产品编码', field: 'symbol'},
            { title: '交易平台', field: 'tradePlatform',render:(data,full)=>{
                return this.arrTrans(data,tradePlatform);
              }},
            { title: '应用平台', field: 'platform',render:(data,full)=>{
                return this.arrTrans(data,platform);
              }},
            { title: '更新时间', field: 'updateTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '渠道', field: 'channel'},
            { title: '用户类型', field: 'type',render:(data,full)=>{
                return this.arrTrans(data,type);
              }},
            { title: '排序', field: 'sort'},
            {title:"操作", btnClick: [
              { name: "修改", size: 'mini', click: 'update', type: 'primary' ,icon:"el-icon-update"},
              { name: "删除", size: 'mini', click: 'delete', type: 'primary' ,icon:"el-icon-delete"}]
            }
          ]
        }
      }
    }
  }
</script>
